/**
 * Narratives being typed but not saved yet, so Release can tell an hourly
 * entry has one before the save lands.
 */
import { create } from "zustand";

type State = {
  drafts: Record<string, string>;
  setDraft: (id: string, text: string) => void;
  clearDraft: (id: string, text: string) => void;
};

export const useNarrativeDrafts = create<State>((set) => ({
  drafts: {},
  setDraft: (id, text) => set((s) => ({ drafts: { ...s.drafts, [id]: text } })),
  clearDraft: (id, text) =>
    set((s) => {
      if (s.drafts[id] !== text) return s;
      const { [id]: _, ...rest } = s.drafts;
      return { drafts: rest };
    })
}));

export const useNarrative = (entry: { id: string; narrative: string }) =>
  useNarrativeDrafts((s) => s.drafts[entry.id]) ?? entry.narrative;

const flushers = new Map<string, () => void>();

/** An open editor's "save now", so Release can save before it sends. */
export const registerFlush = (id: string, flush: () => void) => {
  flushers.set(id, flush);
  return () => {
    if (flushers.get(id) === flush) flushers.delete(id);
  };
};

export const flushDrafts = (ids: string[]) =>
  ids.forEach((id) => flushers.get(id)?.());
